<div class="grid">
  <div class="col-12">
    <div class="card">
      <p-accordion>
        <p-accordionTab header="{{ 'model.machineSelection' | transloco }}" [(selected)]="accordionMachinesSelected">
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <div class="p-datatable-header">
              <div class="flex align-items-center justify-content-end">
                <div class="flex flex-column md:flex-row justify-content-end">
                  <button [label]="'common.filters' | transloco" (click)="filtersVisible = !filtersVisible" pButton
                          class="p-button-secondary" icon="pi pi-sliders-h"></button>
                </div>
              </div>
            </div>
            <p-table #table [(first)]="first" [(rows)]="rows" [paginator]="true" styleClass="p-datatable-striped" (onFilter)="onFilter($event)"
                     [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalMachines" [value]="machines"
                     (onRowSelect)="selectMachine($event.data)" (onRowUnselect)="unselectMachine($event.data)"
                     (onHeaderCheckboxToggle)="selectAllRows($event)"
                     [(selection)]="selectedMachines" [metaKeySelection]="true" dataKey="machineUuid">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col" class="w-3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
                  <th scope="col">{{'attribute.alias' | transloco}}</th>
                  <th scope="col">{{'attribute.model' | transloco}}</th>
                  <th scope="col">{{'model.organization' | transloco}}</th>
                  <th scope="col">{{'attribute.groups' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template let-machine pTemplate="body">
                <tr *ngIf="!loadingMachines">
                  <td>
                    <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                    <p-tableCheckbox [value]="machine"></p-tableCheckbox>
                  </td>
                  <td><a [routerLink]="['/machines', machine.machineUuid, 'details']">{{machine.serial}}</a></td>
                  <td>{{machine.serial}}</td>
                  <td>{{machine.model.modelName}}</td>
                  <td>{{machine.organization.name}} ({{machine.organization.orgCode}})</td>
                  <td>
                    <div *ngIf="machine.groups?.length > 0" class="flex flex-wrap"
                         [ngStyle]="{'gap': '0.5rem', 'max-width': '30rem'}">
                      <p-tag *ngFor="let group of machine.groups;let i=index" value="{{group.name}}" class="group-tag"
                             [style]="{'background': group.color, 'color': adjustTextColor(group.color)}">
                      </p-tag>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="loadingMachines">
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div *ngIf="totalMachines == 0"
                     class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
                <div *ngIf="totalMachines > 0" class="flex align-items-center justify-content-between">
                  {{'pagination.showing' | transloco}} {{first + 1}}
                  {{'pagination.to' | transloco}} {{(first + rows) >= totalMachines ? totalMachines : (first + rows)}}
                  {{'pagination.of' | transloco}} {{totalMachines}}
                  {{(totalMachines > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'model.firmwareIotUpdate' | transloco }}" [(selected)]="accordionFirmwareIotSelected">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label for="firmwareVersionIot">{{'attribute.firmwareVersionIot' | transloco}}: (*)</label>
              </div>
              <div class="col-12 form-field">
                <p-dropdown *ngIf="!this.loadingFilters" [placeholder]="'select.firmwareVersion' | transloco"
                            [filter]="true" styleClass="w-full" [options]="firmwareVersionsIot" id="firmwareVersionIot"
                            [(ngModel)]="selectedVersionIot" (onChange)="selectVersion(FirmwareType.FIRMWARE_IOT)"
                            filterBy="firmwareVersion" appendTo="body" optionLabel="firmwareVersion">
                </p-dropdown>
                <p-skeleton *ngIf="this.loadingFilters" width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="grid mt-2">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label>{{'attribute.selectedMachines' | transloco}}: (*)</label>
              </div>
            </div>
          </div>

          <div class="p-datatable p-component p-datatable-hoverable-rows mt-1">
            <p-table [(first)]="firstSelected" [(rows)]="rowsSelected" [paginator]="true" styleClass="p-datatable-striped"
                     [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="selectedMachines.length"
                     [value]="selectedMachines" dataKey="machineUuid">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
                  <th scope="col">{{'attribute.alias' | transloco}}</th>
                  <th scope="col">{{'attribute.firmwareVersionIot' | transloco}}</th>
                  <th scope="col">{{'attribute.action' | transloco}}</th>
                  <th scope="col">{{'attribute.model' | transloco}}</th>
                  <th scope="col">{{'model.organization' | transloco}}</th>
                  <th scope="col" class="w-10rem"></th>
                </tr>
              </ng-template>
              <ng-template let-machine pTemplate="body">
                <tr>
                  <td><a [routerLink]="['/machines', machine.machineUuid, 'details']">{{machine.serial}}</a></td>
                  <td>{{machine.serial}}</td>
                  <td>{{machine.telemetryData?.firmwareVersionIot}}</td>
                  <td>
                    <p-tag *ngIf="selectedVersionIot && selectedMachinesFirmwareIotActions.get(machine.machineUuid) === this.UPGRADE" value="{{'common.upgrade' | transloco}}" class="green-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionIot && selectedMachinesFirmwareIotActions.get(machine.machineUuid) === this.DOWNGRADE" value="{{'common.downgrade' | transloco}}" class="yellow-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionIot && selectedMachinesFirmwareIotActions.get(machine.machineUuid) === this.NO_ACTION" value="{{'common.noAction' | transloco}}" class="gray-tag state-tag list-tag"></p-tag>
                  </td>
                  <td>{{machine.model.modelName}}</td>
                  <td>{{machine.organization.name}} ({{machine.organization.orgCode}})</td>
                  <td>
                    <div class="flex justify-content-end">
                      <button (click)="unselectMachineFromUpdate(machine)" pButton pRipple class="p-button-rounded btn-primary-light"
                              icon="pi pi-times"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div *ngIf="selectedMachines.length == 0"
                     class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
                <div *ngIf="selectedMachines.length > 0" class="flex align-items-center justify-content-between">
                  {{'pagination.showing' | transloco}} {{firstSelected + 1}}
                  {{'pagination.to' | transloco}} {{(firstSelected + rowsSelected) >= selectedMachines.length ? selectedMachines.length : (firstSelected + rowsSelected)}}
                  {{'pagination.of' | transloco}} {{selectedMachines.length}}
                  {{(selectedMachines.length > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </div>

          <div class="grid" *ngIf="!this.loadingMachines && !this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco" (click)="cancel()" pButton class="p-button-danger"
                          iconPos="right"></button>
                  <p-button [label]="'common.updateMachines' | transloco" (onClick)="updateSelected(FirmwareType.FIRMWARE_IOT)"
                            [disabled]="this.selectedMachines.length === 0 || this.selectedVersionIot == null" [loading]="updatingFirmware"
                            styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>
          <div class="grid" *ngIf="this.loadingMachines || this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <div class="w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                  <div class="w-12rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'model.firmwareMachineUpdate' | transloco }}" [(selected)]="accordionFirmwareMachineSelected">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label for="firmwareVersionMachine">{{'attribute.firmwareVersionMachine' | transloco}}: (*)</label>
              </div>
              <div class="col-12 form-field">
                <p-dropdown *ngIf="!this.loadingFilters" [placeholder]="'select.firmwareVersion' | transloco" [filter]="true"
                            styleClass="w-full" [options]="firmwareVersionsMachineEcu" id="firmwareVersionMachine"
                            [(ngModel)]="selectedVersionMachineEcu" (onChange)="selectVersion(FirmwareType.FIRMWARE_MACHINE_ECU)"
                            filterBy="firmwareVersion" appendTo="body" optionLabel="firmwareVersion"
                >
                </p-dropdown>
                <p-skeleton *ngIf="this.loadingFilters" width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="grid mt-2">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label>{{'attribute.selectedMachines' | transloco}}: (*)</label>
              </div>
            </div>
          </div>

          <div class="p-datatable p-component p-datatable-hoverable-rows mt-1">
            <p-table [(first)]="firstSelected" [(rows)]="rowsSelected" [paginator]="true" styleClass="p-datatable-striped"
                     [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="selectedMachinesZitrux.length"
                     [value]="selectedMachinesZitrux" dataKey="machineUuid">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
                  <th scope="col">{{'attribute.alias' | transloco}}</th>
                  <th scope="col">{{'attribute.firmwareVersionMachine' | transloco}}</th>
                  <th scope="col">{{'attribute.action' | transloco}}</th>
                  <th scope="col">{{'attribute.model' | transloco}}</th>
                  <th scope="col">{{'model.organization' | transloco}}</th>
                  <th scope="col" class="w-10rem"></th>
                </tr>
              </ng-template>
              <ng-template let-machine pTemplate="body">
                <tr>
                  <td><a [routerLink]="['/machines', machine.machineUuid, 'details']">{{machine.serial}}</a></td>
                  <td>{{machine.serial}}</td>
                  <td>{{machine.telemetryData?.machineFirmwareVersion}}</td>
                  <td>
                    <p-tag *ngIf="selectedVersionMachineEcu && selectedMachinesFirmwareMachineEcuActions.get(machine.machineUuid) === this.UPGRADE" value="{{'common.upgrade' | transloco}}" class="green-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionMachineEcu && selectedMachinesFirmwareMachineEcuActions.get(machine.machineUuid) === this.DOWNGRADE" value="{{'common.downgrade' | transloco}}" class="yellow-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionMachineEcu && selectedMachinesFirmwareMachineEcuActions.get(machine.machineUuid) === this.NO_ACTION" value="{{'common.noAction' | transloco}}" class="gray-tag state-tag list-tag"></p-tag>
                  </td>
                  <td>{{machine.model.modelName}}</td>
                  <td>{{machine.organization.name}} ({{machine.organization.orgCode}})</td>
                  <td>
                    <div class="flex justify-content-end">
                      <button (click)="unselectMachineFromUpdate(machine)" pButton pRipple class="p-button-rounded btn-primary-light"
                              icon="pi pi-times"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div *ngIf="selectedMachinesZitrux.length == 0"
                     class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
                <div *ngIf="selectedMachinesZitrux.length > 0" class="flex align-items-center justify-content-between">
                  {{'pagination.showing' | transloco}} {{firstSelected + 1}}
                  {{'pagination.to' | transloco}} {{(firstSelected + rowsSelected) >= selectedMachinesZitrux.length ? selectedMachinesZitrux.length : (firstSelected + rowsSelected)}}
                  {{'pagination.of' | transloco}} {{selectedMachinesZitrux.length}}
                  {{(selectedMachinesZitrux.length > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </div>

          <div class="grid" *ngIf="!this.loadingMachines && !this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco" (click)="cancel()" pButton class="p-button-danger"
                          iconPos="right"></button>
                  <p-button [label]="'common.updateMachines' | transloco" (onClick)="updateSelected(FirmwareType.FIRMWARE_MACHINE_ECU)"
                            [disabled]="this.selectedMachinesZitrux.length === 0 || this.selectedVersionMachineEcu == null"
                            [loading]="updatingFirmware"
                            styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>
          <div class="grid" *ngIf="this.loadingMachines || this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <div class="w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                  <div class="w-12rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'model.firmwareMachineElevatorUpdate' | transloco }}" [(selected)]="accordionFirmwareElevatorMachineSelected">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label for="firmwareVersionMachineElevator">{{'attribute.firmwareVersionMachineElevator' | transloco}}: (*)</label>
              </div>
              <div class="col-12 form-field">
                <p-dropdown *ngIf="!this.loadingFilters" [placeholder]="'select.firmwareVersion' | transloco" [filter]="true"
                            styleClass="w-full" [options]="firmwareVersionsMachineElevator" id="firmwareVersionMachineElevator"
                            [(ngModel)]="selectedVersionMachineElevator" (onChange)="selectVersion(FirmwareType.FIRMWARE_MACHINE_ELEVATOR)"
                            filterBy="firmwareVersion" appendTo="body" optionLabel="firmwareVersion"
                >
                </p-dropdown>
                <p-skeleton *ngIf="this.loadingFilters" width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="grid mt-2">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="col-12 form-field">
                <label>{{'attribute.selectedMachines' | transloco}}: (*)</label>
              </div>
            </div>
          </div>

          <div class="p-datatable p-component p-datatable-hoverable-rows mt-1">
            <p-table [(first)]="firstSelected" [(rows)]="rowsSelected" [paginator]="true" styleClass="p-datatable-striped"
                     [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="selectedMachinesZitrux.length"
                     [value]="selectedMachinesZitrux" dataKey="machineUuid">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
                  <th scope="col">{{'attribute.alias' | transloco}}</th>
                  <th scope="col">{{'attribute.firmwareVersionMachineElevator' | transloco}}</th>
                  <th scope="col">{{'attribute.action' | transloco}}</th>
                  <th scope="col">{{'attribute.model' | transloco}}</th>
                  <th scope="col">{{'model.organization' | transloco}}</th>
                  <th scope="col" class="w-10rem"></th>
                </tr>
              </ng-template>
              <ng-template let-machine pTemplate="body">
                <tr>
                  <td><a [routerLink]="['/machines', machine.machineUuid, 'details']">{{machine.serial}}</a></td>
                  <td>{{machine.serial}}</td>
                  <td>{{machine.telemetryData?.machineFirmwareVersionElevator}}</td>
                  <td>
                    <p-tag *ngIf="selectedVersionMachineElevator && selectedMachinesFirmwareMachineElevatorActions.get(machine.machineUuid) === this.UPGRADE" value="{{'common.upgrade' | transloco}}" class="green-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionMachineElevator && selectedMachinesFirmwareMachineElevatorActions.get(machine.machineUuid) === this.DOWNGRADE" value="{{'common.downgrade' | transloco}}" class="yellow-tag state-tag list-tag"></p-tag>
                    <p-tag *ngIf="selectedVersionMachineElevator && selectedMachinesFirmwareMachineElevatorActions.get(machine.machineUuid) === this.NO_ACTION" value="{{'common.noAction' | transloco}}" class="gray-tag state-tag list-tag"></p-tag>
                  </td>
                  <td>{{machine.model.modelName}}</td>
                  <td>{{machine.organization.name}} ({{machine.organization.orgCode}})</td>
                  <td>
                    <div class="flex justify-content-end">
                      <button (click)="unselectMachineFromUpdate(machine)" pButton pRipple class="p-button-rounded btn-primary-light"
                              icon="pi pi-times"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div *ngIf="selectedMachinesZitrux.length == 0"
                     class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
                <div *ngIf="selectedMachinesZitrux.length > 0" class="flex align-items-center justify-content-between">
                  {{'pagination.showing' | transloco}} {{firstSelected + 1}}
                  {{'pagination.to' | transloco}} {{(firstSelected + rowsSelected) >= selectedMachinesZitrux.length ? selectedMachinesZitrux.length : (firstSelected + rowsSelected)}}
                  {{'pagination.of' | transloco}} {{selectedMachinesZitrux.length}}
                  {{(selectedMachinesZitrux.length > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </div>

          <div class="grid" *ngIf="!this.loadingMachines && !this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco" (click)="cancel()" pButton class="p-button-danger"
                          iconPos="right"></button>
                  <p-button [label]="'common.updateMachines' | transloco" (onClick)="updateSelected(FirmwareType.FIRMWARE_MACHINE_ELEVATOR)"
                            [disabled]="this.selectedMachinesZitrux.length === 0 || this.selectedVersionMachineElevator == null"
                            [loading]="updatingFirmware"
                            styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>
          <div class="grid" *ngIf="this.loadingMachines || this.loadingFilters">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <div class="w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                  <div class="w-12rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>

      </p-accordion>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="serial">{{'attribute.serialNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.serialNumbers" [placeholder]="'select.generic' | transloco"
                       [options]="this.machines" [filter]="true" filterBy="serial" display="chip" styleClass="w-full"
                       appendTo="body" id="serial" optionLabel="serial" optionValue="serial">
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="model">{{'attribute.model' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineModelUuids" [placeholder]="'select.generic' | transloco"
                       [filter]="true" filterBy="modelName" display="chip" styleClass="w-full" appendTo="body" [options]="models"
                       id="model" optionLabel="modelName" optionValue="machineModelUuid">
          <ng-template let-model pTemplate="item">
            <div class="flex align-items-center">
              <div style="width:30px;">
                <img [src]="model.image" [alt]="model.modelName" style="max-height: 30px;max-width: 100%;" />
              </div>
              <p class="mb-0 ml-1 p-0">{{model.modelName}}</p>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organizationName">{{'attribute.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.organizationName" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="organizationName" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="group">{{'attribute.machineGroup' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineGroups" [placeholder]="'select.generic' | transloco"
                       [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body" [options]="this.groups"
                       id="group" optionLabel="name">
          <ng-template let-group pTemplate="item">
            <div class="flex align-items-center">
              <p-tag value="{{group.name}}" class="group-tag"
                     [style]="{'background': group.color, 'color': adjustTextColor(group.color)}"></p-tag>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button [label]="'common.filter' | transloco" [disabled]="!(
            currentFilters.serialNumbers ||
            currentFilters.machineModelUuids ||
            currentFilters.organizationName ||
            currentFilters.machineGroups
          )" (onClick)="filtersVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
      </p-button>
      <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersVisible = false; applyFilters()"
                styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>
